import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MainService } from './main.service';
import { map } from 'rxjs/operators';
import { ContentRequestBody } from '../_models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class ContentcmsService {

  constructor(
    private http: HttpClient,
    private main: MainService
  ) { }

  public getContent(entity: string, params: ContentRequestBody = {}) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/content/application/${this.main.siteName()}/entity/${entity}`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getContentRefence(content: string, entity: string, params: ContentRequestBody = {}) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/content/entity/${content}/reference/${entity}`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  /* public getCategoryContent(category: string, params: ContentRequestBody = {}) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/content/application/${this.main.siteName()}/category/${category}`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  } */

  public getContentDetail(entity: string, references: boolean = false) {
    return this.http.get<any>(`${this.main.relativeUrl}/integrated-twt/content/entity/${entity}?lang=${this.main.userStorage().l?.replace('-', '_') || ''}&withReferences=${references}`, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

}